export const base_api_url = process.env.REACT_APP_api_base_url

export const SSO_auth_path = process.env.REACT_APP_SSO_auth_path

export const default_api_timeout = 30000